<template>
  <toggle-button
    v-bind="$attrs"
    :tag="tag"
    :on-activate="follow"
    :on-deactivate="unfollow"
    :disabled="!authenticated || busy"
    :is-active="isUserFollowingCase"
  >
    <template #icon>
      <follow-icon />
    </template>

    <template #on>
      <span class="d-md-none ml-2">{{ $t('cmrad.unfollow') }}</span>
      <span class="d-none d-md-inline ml-2">{{ $t('cmrad.unfollow') }} {{ $t('cmrad.case') }}</span>
    </template>

    <template #off>
      <span class="d-md-none ml-2">{{ $t('cmrad.follow') }}</span>
      <span class="d-none d-md-inline ml-2">{{ $t('cmrad.follow') }} {{ $t('cmrad.case') }}</span>
    </template>
  </toggle-button>
</template>

<script>
  import FollowIcon from '@/Atoms/svgIcons/FollowIcon';
  import ToggleButton from '@/Molecules/ToggleButton';
  import { mapActions, mapGetters } from 'vuex';

  export default {
    name: 'FollowCaseButton',

    components: {
      FollowIcon,
      ToggleButton,
    },

    props: {
      targetCase: Object,
      tag: {
        type: String,
        default: 'icon-button',
      },
    },

    computed: {
      ...mapGetters(['busy', 'isFollowingCase']),
      isUserFollowingCase() {
        return this.targetCase ? this.targetCase.isFollowingCase || this.targetCase.following : this.isFollowingCase;
      },

      authenticated() {
        return this.$store.getters.authenticated;
      },
    },

    methods: {
      ...mapActions(['followCase', 'unFollowCase']),
      follow() {
        return this.targetCase ? this.followCase(this.targetCase) : this.followCase();
      },
      unfollow() {
        return this.targetCase ? this.unFollowCase(this.targetCase) : this.unFollowCase();
      },
    },
  };
</script>

<style lang="scss" scoped></style>
